// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2680":"eda5e988","5478":"2651baba"}[chunkId] + ".chunk.js";
};